export default {
  namespaced: true,
  state: {
    counter: 0
  },
  getters: {
    getPosition: state => {
      return state.counter > 0 ? state.counter - 1 : 0;
    }
  },
  mutations: {
    inc: state => {
      state.counter++;
    },
    dec: state => {
      state.counter--;
    }
  },
  actions: {
    inc: ({ commit }) => {
      return new Promise(resolve => {
        commit("inc");
        resolve();
      });
    },
    dec: ({ commit }) => {
      return new Promise(resolve => {
        commit("dec");
        resolve();
      });
    }
  }
};
